export default __webpack_public_path__ + "static/media/medium.2ab063fe.woff";